export default __webpack_public_path__ + "static/media/athens.46a56778.png";